module.exports = __webpack_public_path__ + "img/shy-banner.9746a5bb.png";